import classNames from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import aymo from '../../../../assets/images/aymo_new.png';
import { ReactComponent as LinkIcon } from '../../../../assets/images/link-forward.svg';
import { useMedia } from '../../../context/InterfaceContext';
import Divider from '../Divider';
import styles from '../product/product.module.scss';
import StrongText from '../StrongText';
import './index.scss';

const AymoProduct: FC<{ horizonMode?: boolean }> = ({ horizonMode = false }) => {
    const intl = useIntl();
    const { isMobile, isMobileMiddle } = useMedia();
    const AYMO_LINK = intl.formatMessage({
        id: 'product.aymo.link',
        defaultMessage: 'https://www.apgsga.ch/de/digital-und-mobile/aymo-uebersicht/',
    });

    if (AYMO_LINK) {
        return (
            <div
                className={classNames(styles.wrapper, styles.aymoLinkWrapper, {
                    [styles.horizontalMode]: isMobile || isMobileMiddle ? false : horizonMode,
                })}
            >
                <a href={AYMO_LINK} target={'_blank'} rel="noreferrer" className={styles.linkWrapper}>
                    <div className={styles.imgWrapper}>
                        <img src={aymo} alt="Product image" loading="lazy" />
                    </div>

                    <div className={styles.description}>
                        <StrongText className={styles.format}>
                            {intl.formatMessage({ id: 'product.aymo.name', defaultMessage: 'aymo Mobile Targeting' })}
                        </StrongText>

                        <Divider />

                        <div className={classNames(styles.address, styles.addressFullHeight)}>
                            {intl.formatMessage({
                                id: 'product.aymo.description',
                                defaultMessage:
                                    'aymo GeoTarget und aymo AudienceTarget verstärken die Sichtbarkeit Ihrer regionalen Kampagne und schaffen Reichweite und Bekanntheit für Ihr Unternehmen.',
                            })}
                        </div>

                        <a href={AYMO_LINK} target={'_blank'} rel="noreferrer" className={'more-link-aymo'}>
                            {intl.formatMessage({ id: 'product.aymo.linkName', defaultMessage: 'Mehr erfahren' })}
                            <LinkIcon />
                        </a>
                    </div>
                </a>
            </div>
        );
    }

    return null;
};

export default AymoProduct;
